import { component$ } from '@builder.io/qwik';

export const StartScreen = component$(() => {
  return null;
});
